import { makeAutoObservable, runInAction } from "mobx";
import Constants from "../../../../constants/Common";
import { StatusInfo, WithBooleanFlag } from "../../../../store/core";
import Api from "./LoginPageApi";

export class LogtinPageStore {
  supportAddress = "";
  email = "";
  messageStatus = new StatusInfo();
  isloading = new WithBooleanFlag(false);
  constructor() {
    makeAutoObservable(this);
  }
  getdataHelp = async () => {
    try {
      this.isloading.setTrue();
      const res = await Api.datahelp();
      runInAction(() => {
        this.supportAddress = res.data.supportAddress;
        this.email = res.data.email;
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.isloading.setFalse();
    }
  };
  updatedataHelp = async (data) => {
    try {
      this.isloading.setTrue();
      const res = await Api.savedataHelp(data);
      this.messageStatus.setStatus(Constants.statusMessage.updated);
    } catch (error) {
      this.messageStatus.setDetails(error);
      this.messageStatus.setStatus(Constants.requestStatuses.error);
    }
    finally{
      this.isloading.setFalse();
    }
  };
  getContactLogin = async() =>{
    try{
      this.isloading.setTrue();
      const res = await Api.getContactPublic();
      this.supportAddress = res.data.supportAddress;
    }
    catch(error){
      this.messageStatus.setDetails(error);
      this.messageStatus.setStatus(Constants.requestStatuses.error);
    }
    finally{
      this.isloading.setFalse();
    }
  }
}
export const loginStore = new LogtinPageStore();
